import { render, staticRenderFns } from "./BasicSlider.vue?vue&type=template&id=46d7f7be&"
import script from "./BasicSlider.vue?vue&type=script&lang=js&"
export * from "./BasicSlider.vue?vue&type=script&lang=js&"
import style0 from "./BasicSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports